import { clientFetch } from '../clientFetch';

export const wpPostsByCategory = ({
  params: { parentCategory, category, getContent, page, perPage, order, sort, cacheExpiry, embed, sticky, ...params },
  signal,
}) => {
  return clientFetch('/wp/posts/category', {
    params: { parentCategory, category, getContent, page, perPage, order, sort, cacheExpiry, embed, sticky, ...params },
    signal,
  });
};
